import uuid from 'core/utils/uuid'
import * as types from 'store/mutation-types'
import api from 'store/modules/builder/api'
import authApi from 'store/modules/auth/api'
import router from 'app/routes'

export default {
  [types.SET_TEMPLATE_COLUMNS_MODE] ({ commit, state }, { mode, index }) {
    const row = state.templates[state.currentTemplate].rows[index]

    if (row) {
      const newArray = []
      const columnSchema = mode.split('-')
      let newItems = 3
      let columns = JSON.parse(JSON.stringify(row.columns))

      while (newItems--) {
        newArray.push({
          id: uuid(),
          components: []
        })
      }

      columns = [...columns, ...newArray]
      columns.length = columnSchema.length

      mode.split('-').forEach((item, itemIndex) => {
        columns[itemIndex].width = +item
      })

      commit(types.SET_TEMPLATE_COLUMNS_MODE, {
        columns,
        index
      })
    }
  },
  [types.COPY_MOBILE_CHECKOUT_TO_DESKTOP] ({ commit, state, dispatch }) {
    const { templates, currentLanguage } = state
    const mobileCheckout = JSON.parse(JSON.stringify(templates['mobile-' + currentLanguage]))
    const desktopCheckout = JSON.parse(JSON.stringify(templates['desktop-' + currentLanguage]))
    let newCheckout = {
      ...mobileCheckout,
      checkoutMode: 1,
      rows: [],
      editMode: desktopCheckout.editMode
    }

    mobileCheckout.rows.forEach(row => {
      row.columns.forEach(column => {
        let newRow = {
          id: uuid(),
          columns: [
            {
              id: uuid(),
              width: 3,
              components: []
            }
          ]
        }

        if (column.components.length) {
          column.components.forEach(component => {
            newRow.columns[0].components.push(component)
            newCheckout.rows.push(JSON.parse(JSON.stringify(newRow)))
            newRow.columns[0].components.length = 0
          })
        } else if (column.width === 3) {
          newCheckout.rows.push(newRow)
        }
      })
    })

    commit(types.SET_CHECKOUT_HISTORY, desktopCheckout)
    commit(types.COPY_MOBILE_CHECKOUT_TO_DESKTOP, JSON.parse(JSON.stringify(newCheckout)))
    commit(types.SET_LAST_UPDATED_PLATFORM)
    commit(types.SET_TEMPLATE_UNSAVED_CHANGES, true)
    commit(types.SET_LAYOUT_IS_COPIED, true)
  },
  [types.SET_CURRENT_PLATFORM] ({ commit, state, dispatch }, platform) {
    if (!state.templates['desktop-' + state.currentLanguage].rows[0] && state.templates['mobile-' + state.currentLanguage].rows[0]) {
      dispatch(types.COPY_MOBILE_CHECKOUT_TO_DESKTOP)
    }

    commit(types.SET_CURRENT_PLATFORM, platform)
  },
  [types.ADD_COMPONENT_TO_ROW_AND_COLUMN] ({ commit, rootState: { datahubEvents } }, { row, column, currentComponent }) {
    const { imageList } = currentComponent
    if (currentComponent?.name === 'hotpay-order-bump') {
      commit('datahubEvents/SET_INSTALLMENT_BUMPS_ADDED', [...datahubEvents.installmentBumpsAdded, currentComponent.data.product], { root: true })
    }
    if (imageList !== null && imageList.length > 0) {
      imageList.forEach(currentImage => {
        if (Object.keys(currentImage).length) {
          commit('ADD_IMAGE', currentImage)
        }
      })

      delete currentComponent.imageList
    }

    commit(types.ADD_COMPONENT_TO_ROW_AND_COLUMN, { row, column, currentComponent })
  },
  [types.SAVE_CHECKOUT_BACKGROUND_IMAGE] ({ commit }, backgroundImage) {
    if (Object.keys(backgroundImage).length) {
      commit('ADD_IMAGE', backgroundImage)
    }

    commit(types.SAVE_CHECKOUT_BACKGROUND_IMAGE, backgroundImage)
  },
  [types.EDIT_COMPONENT] ({ commit }, componentData) {
    const { imageList } = componentData

    if (imageList !== null && imageList.length > 0) {
      imageList.forEach(currentImage => {
        if (Object.keys(currentImage).length) {
          commit('ADD_IMAGE', currentImage)
        }
      })

      delete componentData.imageList
    }

    commit(types.EDIT_COMPONENT, componentData)
  },
  [types.ADD_SLOT_COMPONENT] ({ commit }, slotComponent) {
    const { imageList } = slotComponent

    if (imageList !== null && imageList.length > 0) {
      imageList.forEach(currentImage => {
        if (Object.keys(currentImage).length) {
          commit('ADD_IMAGE', currentImage)
        }
      })

      delete slotComponent.imageList
    }

    commit('ADD_SLOT_COMPONENT', slotComponent)
  },
  [types.EDIT_SLOT_COMPONENT] ({ commit, getters }, slug) {
    commit('SET_CURRENT_COMPONENT', {
      name: slug,
      componentBody: getters.currentSlotComponents[slug]
    })

    commit('SET_CANVAS_EDIT_MODE', {
      status: true
    })

    commit('SET_CURRENT_EDIT_FORM', slug)
  },
  [types.ADD_IN_CHECKOUT_COMPONENT] ({ commit }, inCheckoutComponent) {
    const { imageList } = inCheckoutComponent

    if (imageList !== null && imageList.length > 0) {
      imageList.forEach(currentImage => {
        if (Object.keys(currentImage).length) {
          commit('ADD_IMAGE', currentImage)
        }
      })

      delete inCheckoutComponent.imageList
    }

    commit('ADD_IN_CHECKOUT_COMPONENT', {
      id: uuid(),
      ...inCheckoutComponent
    })
  },
  [types.SET_EDIT_IN_CHECKOUT_COMPONENT] ({ commit, getters }, inCheckoutId) {
    const { inCheckoutComponents } = getters.activeTemplate
    const currentComponent = inCheckoutComponents.find(item => item.id === inCheckoutId)
    const name = currentComponent.inCheckout.replace('hotpay-', '')

    commit('SET_CURRENT_COMPONENT', {
      name,
      componentBody: currentComponent
    })

    commit('SET_CANVAS_EDIT_MODE', {
      status: true
    })

    commit('SET_CURRENT_EDIT_FORM', name)
  },
  async [types.EDIT_IN_CHECKOUT_COMPONENT] ({ commit, dispatch, getters, state }, inCheckoutComponent) {
    const { imageList } = inCheckoutComponent

    if (imageList !== null && imageList.length > 0) {
      imageList.forEach(currentImage => {
        if (Object.keys(currentImage).length) {
          commit('ADD_IMAGE', currentImage)
        }
      })

      delete inCheckoutComponent.imageList
    }

    commit('EDIT_IN_CHECKOUT_COMPONENT', {
      id: getters.currentComponent.id,
      ...inCheckoutComponent
    })
  },
  [types.EDIT_SLOT_COMPONENT] ({ commit, getters }, slug) {
    commit('SET_CURRENT_COMPONENT', {
      name: slug,
      componentBody: getters.currentSlotComponents[slug]
    })

    commit('SET_CANVAS_EDIT_MODE', {
      status: true
    })

    commit('SET_CURRENT_EDIT_FORM', slug)
  },
  async [types.SET_COMPONENT_IN_DROP_MODE] ({ commit, dispatch }, componentData) {
    await commit('SET_CURRENT_COMPONENT', {
      componentBody: componentData,
      name: componentData.name.replace('hotpay-', '')
    })

    if (componentData.data.fixed) {
      dispatch('INSERT_FIXED_COMPONENT')
    } else {
      await commit('SET_CANVAS_INSERT_MODE', true)
    }
  },
  async [types.INSERT_FIXED_COMPONENT] ({ commit, dispatch, state }) {
    const coords = {
      row: 0,
      column: 0,
      currentComponent: state.currentComponent
    }

    const scrollerEl = document.querySelector('.builder-content-scroller')

    await commit('INSERT_TEMPLATE_ROW_BEFORE', 0)
    await dispatch('ADD_COMPONENT_TO_ROW_AND_COLUMN', coords)
    await commit('SET_LAST_INSERT_COMPONENT', coords)
    await commit('CLEAR_STATE_MODES', null)

    if (scrollerEl) {
      scrollerEl.scrollTo(0, 0)
    }
  },
  async [types.SAVE_NEW_CHECKOUT_TO_PUBLISH] ({ commit, dispatch, state, getters, rootState: { auth } }, { checkoutId }) {
    const editMode = Boolean(!!checkoutId || checkoutId)

    const { templateId } = router.history.current.params
    const { currentProduct } = auth
    const {
      checkoutDescription,
      checkoutName,
      currentProductEarlyRenewal,
      imageList,
      previewWasOpen,
      templates
    } = state

    const { data } = await api.saveCheckout({
      checkoutDescription,
      checkoutId,
      checkoutName,
      currentProduct,
      currentProductEarlyRenewal,
      editMode,
      imageList,
      templateId,
      templates
    })

    if (previewWasOpen) {
      dispatch('datahubEvents/SEND_USE_PREVIEW_AND_PUBLISH', null, { root: true })
    }

    if (data) {
      commit(types.SET_TEMPLATE_UNSAVED_CHANGES, false)
      commit('dashboard/SET_CHECKOUT_DATA', data, { root: true })
      commit('dashboard/SET_NEED_FEEDBACK', true, { root: true })
    }
  },
  async [types.ADD_PRODUCT_WITH_ENRICHED_DATA] ({ commit, state }, product) {
    if (!product.id) return

    const productAlreadyHasEnrichedData = state.productsWithEnrichedData[product.id]

    if (productAlreadyHasEnrichedData) { return }

    try {
      const {
        products: [productEnrichedData]
      } = await authApi.getProductsByName(product?.productName)

      commit(types.SET_PRODUCTS_WITH_ENRICHED_DATA, {
        ...state.productsWithEnrichedData,
        [product.id]: productEnrichedData
      })
    } catch (err) {
      console.error(err)
    }
  }
}
